import { updateApplication } from '../../../service/api';

/** call updateApplication API for FileInput */
export const handleSaveFileProperty = async ({
  appData,
  sanitizeData,
  setLoading,
  updateAppData,
  stateRef,
}) => {
  const fileFeature = appData?.applicationFeatures.find(
    (feature) => feature.itemType === 'FileProperty'
  );

  setTimeout(async () => {
    // To call update API with the updated state data, delay api call
    const sanitizedData = sanitizeData(stateRef.current);

    const updatedData = await updateApplication([
      {
        itemType: fileFeature.itemType,
        dataType: fileFeature.dataType,
        name: fileFeature.name,
        value: sanitizedData,
      },
    ]);

    if (updatedData.data) {
      updateAppData(updatedData.data);
    }
  }, 1000);
};
